'use client';

import { Container, useModal, TypeformSnippet } from '..';
import { CaptionWithMB, H2 } from './styleConstants';
import React from 'react';
import { useTranslations } from 'next-intl';
import styles from './UltrasignalSection.module.css';

const UltraSignalTFModal = () => {
  const t = useTranslations('partners');
  return (
    <div className={styles.tfModal}>
      <TypeformSnippet
        typeformId="WwKw67nO"
        frameTitle={t('ultrasignal.modalFrameTitle')}
        className="typeform-container"
      />
    </div>
  );
};

export const UltrasignalSection = ({ className }: { className?: string }) => {
  const t = useTranslations('partners');
  const ModalClient = useModal();

  const showApplyModal = () => {
    ModalClient.set(<UltraSignalTFModal />);
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  return (
    <section className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <Container className={styles.container}>
        <div className={styles.textContent}>
          <CaptionWithMB>{t('solutionCaption')}</CaptionWithMB>
          <H2
            className={styles.heading}
            style={{ margin: '0 auto 12px', color: '#000000' }}
          >
            {t('ultrasignal.title')}
          </H2>
          {/* <Subtitle style={{ margin: '0 auto' }}>
            A unified enterprise-grade dashboard for teams and clinicians to
            track sleep, recovery, movement, cycles, and long-term health using
            continuous biomarkers.
          </Subtitle> */}
        </div>
        <div className={styles.mediaContainer}>
          <div className={styles.iframeContainer}>
            <iframe
              title="Unicorn Studio"
              src={'https://unicorn.studio/embed/C0XlH8smsOLQgZ0RTY3U'}
              loading="lazy"
            ></iframe>
          </div>
          <div className={styles.contentContainer}>
            {/* <p className="tag">ULTRASIGNAL</p> */}
            <H2 className={styles.heading}>UltraSignal</H2>
            <p className={styles.subtitle}>{t('ultrasignal.subtitle')}</p>
            <div className={styles.ctaContainer}>
              <button className={styles.primaryButton} onClick={showApplyModal}>
                {t('ultrasignal.cta')}
              </button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
